import { render, staticRenderFns } from "./ViewPageViews.modal.vue?vue&type=template&id=d1bc8182"
import script from "./ViewPageViews.modal.vue?vue&type=script&lang=ts"
export * from "./ViewPageViews.modal.vue?vue&type=script&lang=ts"
import style0 from "./ViewPageViews.modal.vue?vue&type=style&index=0&id=d1bc8182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports